import { PhoneCallEventDirection } from '../../../domain/types';

export enum CallContextType {
  LEAD = 'LEAD',
  COLD_LEAD = 'COLD_LEAD',
  SURVEY = 'SURVEY',
  NONE = 'NONE',
}

export enum CallMedium {
  AIRCALL = 'AIRCALL',
  MOBILE = 'MOBILE',
}

export interface Call {
  id?: string,
  correlationId?: string,
  medium?: CallMedium,
  direction: PhoneCallEventDirection,
  startedAt: string,
  duration?: number,
  answered: boolean,
  leadTransformationSpecialist: string,
  inboundNumber?: string,
  outboundNumber?: string,
  context: {
    type: CallContextType,
    id: string,
  }
}
